export default __webpack_public_path__ + "static/media/Pirates.c4d78e9f.png";